/** 万能渲染模型发布（KleinFlux）相关常量与类型 */

export const LORA_TYPE_KLEIN_FLUX = 'KleinFlux' as const;

export type PublishLoraType = 'LoRA' | 'Style' | typeof LORA_TYPE_KLEIN_FLUX;

export const UNIVERSAL_RENDER_STYLE_CATEGORY_NAME = '万能渲染风格';

/** 万能渲染在后端标签体系中的 level-2 ID，用于 getModelLabelInfoByLevel2Id 接口 */
export const UNIVERSAL_RENDER_LEVEL2_ID = 88;

export const KLEIN_FLUX_MAX_LABEL_COUNT = 2;

export const DEFAULT_MAX_LABEL_COUNT = 5;

/** 示例图数量上限（含 KleinFlux，与 LoRA/Style 一致） */
export const DEFAULT_MAX_SAMPLE_COUNT = 20;

/** 提交/详情 API 中 comparisonImg 的单项：before 为空串表示普通图（非对比图） */
export interface ComparisonImagePayloadItem {
  before: string;
  after: string;
  source: 'creation' | 'local';
  artworkId?: number;
}

/** 版本内 UI 状态（提交前） */
export type PublishPreviewEntry =
  | {
      kind: 'image';
      uid: string;
      preview: string;
      source: 'creation' | 'local';
      artworkId?: number;
    }
  | {
      kind: 'comparison';
      uid: string;
      before: string;
      after: string;
      source: 'creation' | 'local';
      artworkId?: number;
    };

export function isKleinFluxLoraType(loraType?: string): loraType is typeof LORA_TYPE_KLEIN_FLUX {
  return loraType === LORA_TYPE_KLEIN_FLUX;
}

export function isKleinTrainModel(data: { ckptType?: string }): boolean {
  return data.ckptType === 'Klein';
}
